import { decamelizeKeys as fastCaseDecamelizeKeys } from 'fast-case';

type ObjectOrArray = Record<string, unknown> | unknown[];

export const decamelizeKeys = (
  obj: unknown,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  options?: { deep?: boolean }
): any => {
  // deep is already handled by fast-case
  return fastCaseDecamelizeKeys(obj as ObjectOrArray);
};
